<template>

  <section class="wrapper">
    <header class="mainHeader"
            role="banner">
      <div class="container-fluid">
        <div class="navbarWrapper">
          <div class="navbarGroupItem navBarItemLeft">
            <div class="brand_img">
              <router-link :to="{ name: 'offtaker.dashboard'}"
                           class="logo_link">
                <img :src="`${$baseImageUrl}/logo.svg`"
                     alt="FarmZone" />
              </router-link>
            </div>
          </div>
          <div class="navbarGroupItem navBarItemCenter">
            <nav class="navMenu menuPrimary">
              <div class="menuListItem" 
              :class="[$route.name === 'offtaker.dashboard' ? 'is-active' : '']">
                <router-link :to="{name: 'offtaker.dashboard'}"
                   class="menuLinkItem">Dashboard</router-link>
              </div>
              <div class="menuListItem"
              :class="[$route.name === 'offtaker.mycrops' ? 'is-active' : '']">
                <router-link :to="{name: 'offtaker.mycrops'}"
                   class="menuLinkItem">My Crops</router-link>
              </div>

              <div class="menuListItem"
              :class="[$route.name === 'offtaker.discovercrops' ? 'is-active' : '']">
                <router-link :to="{ name: 'offtaker.discovercrops'}"
                   class="menuLinkItem">Discover</router-link>
              </div>
            </nav>
          </div>
          <div class="navbarGroupItem navBarItemRight">
            <nav class="navMenu menuAlt">
              <div class="dropdown">
                <a href="#" data-toggle="dropdown" class="dropdown-toggle" aria-expanded="true">
                  <div class="controlBadge badgeChat">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M6.00407 13.1685H17.0241C18.2737 13.1685 19.293 12.1491 19.293 10.8995V6.26299C19.293 6.25888 19.293 6.25066 19.293 6.24654C19.293 6.23421 19.293 6.22599 19.293 6.21366C19.293 6.20544 19.293 6.19722 19.2889 6.189C19.2889 6.18078 19.2848 6.16845 19.2848 6.16023C19.2848 6.15201 19.2807 6.14378 19.2807 6.13556C19.2766 6.12734 19.2766 6.11912 19.2725 6.10679C19.2684 6.09857 19.2684 6.09035 19.2643 6.08213C19.2602 6.07391 19.2602 6.06569 19.256 6.05747C19.2519 6.04925 19.2478 6.04102 19.2437 6.02869C19.2396 6.02047 19.2355 6.01225 19.2314 6.00814C19.2273 5.99992 19.2232 5.9917 19.2191 5.98348C19.2149 5.97526 19.2108 5.97115 19.2067 5.96293C19.2026 5.95471 19.1944 5.94648 19.1903 5.93826C19.1862 5.93004 19.1821 5.92593 19.1738 5.91771C19.1697 5.90949 19.1615 5.90538 19.1574 5.89716C19.1533 5.88894 19.1451 5.88483 19.141 5.87661C19.1368 5.86839 19.1286 5.86428 19.1245 5.86017C19.1163 5.85195 19.1122 5.84784 19.104 5.83961C19.0957 5.8355 19.0916 5.82728 19.0834 5.82317C19.0752 5.81906 19.067 5.81084 19.0587 5.80673C19.0505 5.80262 19.0464 5.79851 19.0382 5.7944C19.03 5.79029 19.0218 5.78618 19.0135 5.77796C19.0053 5.77385 18.9971 5.76974 18.9889 5.76563C18.9806 5.76152 18.9724 5.75741 18.9642 5.7533C18.956 5.74919 18.9478 5.74508 18.9395 5.74096C18.9313 5.73685 18.9231 5.73685 18.9149 5.73274C18.9067 5.72863 18.8943 5.72452 18.8861 5.72452C18.8779 5.72452 18.8697 5.72041 18.8656 5.72041C18.8532 5.7163 18.845 5.7163 18.8327 5.7163C18.8286 5.7163 18.8245 5.71219 18.8162 5.71219L4.84904 3.78441V1.83607C4.84904 1.81552 4.84904 1.79497 4.84493 1.77852C4.84493 1.77441 4.84493 1.7703 4.84082 1.76208C4.84082 1.74975 4.83671 1.73742 4.83671 1.72509C4.8326 1.71276 4.8326 1.70454 4.82849 1.69221C4.82849 1.68399 4.82438 1.67987 4.82438 1.67165C4.82027 1.65932 4.81616 1.64699 4.81205 1.63466C4.81205 1.63055 4.80794 1.62233 4.80794 1.61822C4.80383 1.60589 4.79972 1.59767 4.7915 1.58534C4.78739 1.58122 4.78739 1.573 4.78328 1.56889C4.77917 1.56067 4.77506 1.55245 4.76684 1.54423C4.76273 1.53601 4.75862 1.5319 4.7545 1.52368C4.75039 1.51546 4.74628 1.51135 4.74217 1.50313C4.73806 1.49491 4.72984 1.48669 4.72573 1.47846C4.72162 1.47435 4.71751 1.47024 4.7134 1.46613C4.70518 1.45791 4.69696 1.44969 4.68874 1.44147C4.68463 1.43736 4.68052 1.43325 4.67641 1.42914C4.66819 1.42092 4.65997 1.4127 4.64763 1.40448C4.64352 1.40037 4.6353 1.39626 4.63119 1.39215C4.62297 1.38392 4.61475 1.37981 4.60653 1.37159C4.5942 1.36337 4.58187 1.35515 4.57365 1.35104C4.56954 1.34693 4.56543 1.34693 4.56132 1.34282C4.54487 1.3346 4.52432 1.32638 4.50788 1.31816L1.4785 0.0439301C1.19489 -0.075272 0.870163 0.0562613 0.750961 0.33988C0.631759 0.623498 0.763293 0.948221 1.04691 1.06742L3.73512 2.2019V4.71747V5.11618V8.17433V10.9078V14.3605C3.73512 15.5114 4.59831 16.465 5.71223 16.6089C5.51082 16.946 5.39162 17.3406 5.39162 17.7598C5.39162 18.997 6.39867 20 7.63179 20C8.86492 20 9.87197 18.9929 9.87197 17.7598C9.87197 17.3488 9.76099 16.9583 9.56369 16.6295H14.5537C14.3564 16.9624 14.2455 17.3488 14.2455 17.7598C14.2455 18.997 15.2525 20 16.4856 20C17.7188 20 18.7258 18.9929 18.7258 17.7598C18.7258 16.5267 17.7188 15.5196 16.4856 15.5196H6.00407C5.36285 15.5196 4.84493 14.9976 4.84493 14.3605V12.8561C5.18199 13.0534 5.5807 13.1685 6.00407 13.1685ZM8.76627 17.7557C8.76627 18.3805 8.25658 18.8861 7.6359 18.8861C7.01523 18.8861 6.50554 18.3764 6.50554 17.7557C6.50554 17.135 7.01523 16.6253 7.6359 16.6253C8.25658 16.6253 8.76627 17.1309 8.76627 17.7557ZM17.6201 17.7557C17.6201 18.3805 17.1104 18.8861 16.4897 18.8861C15.8691 18.8861 15.3594 18.3764 15.3594 17.7557C15.3594 17.135 15.8691 16.6253 16.4897 16.6253C17.1104 16.6253 17.6201 17.1309 17.6201 17.7557ZM17.0241 12.0587H6.00407C5.36285 12.0587 4.84493 11.5366 4.84493 10.8995V8.16611V5.10796V4.90244L18.1832 6.73979V10.8954C18.1832 11.5408 17.6612 12.0587 17.0241 12.0587Z"
                        fill="#23331A" />
                    </svg>
                    <span class="controlBadgeCount">{{cart.length}}</span>
                  </div>
                </a>

                <div class="dropdown-menu mt-4 p-0 dpMenu" style="width: 390px;">
                  <div class="cart__items__dropdown">
                    <div class="closeItem">
                      <a href="#">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289Z"
                            fill="#959595" />
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                            fill="#959595" />
                        </svg>
                      </a>
                    </div>
                    <div class="row margin_bottom_sm">
                      <h4 class="font-bold font-sm margin_top_sm caps_upper" style="z-index: 5">Cart Items</h4>
                    </div>
                    <cart-item v-for="(c, index) in cart" :key="index" :cartItem="c" />

                    <div class="row borderBottom" v-if="cart.length === 0">
                      <p class="font-bold font-md">You have no item in your cart</p>
                    </div>
                    
                    <div v-if="cart.length !== 0" class="row d-flex justify-content-between align-items-center margin_top_md">
                        <a href="#" @click.prevent="clearCart">Clear cart</a>
                        <button class="btn btn-secondary-outline btn-sm p-2 mr-3" @click="viewCart">
                          View cart
                        </button>
                    </div>
                  </div>

                </div>
              </div>

              <!-- <div class="controlBadge badgeNotification">
                <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.99992 2.49998C8.67384 2.49998 7.40207 3.02676 6.46438 3.96445C5.5267 4.90213 4.99992 6.1739 4.99992 7.49998V11.6666C4.99992 12.2568 4.8434 12.8309 4.55335 13.3333H15.4465C15.1564 12.8309 14.9999 12.2568 14.9999 11.6666V7.49998C14.9999 6.1739 14.4731 4.90213 13.5355 3.96445C12.5978 3.02676 11.326 2.49998 9.99992 2.49998ZM18.3333 13.3333C17.8912 13.3333 17.4673 13.1577 17.1547 12.8452C16.8422 12.5326 16.6666 12.1087 16.6666 11.6666V7.49998C16.6666 5.73187 15.9642 4.03618 14.714 2.78593C13.4637 1.53569 11.768 0.833313 9.99992 0.833313C8.23181 0.833313 6.53612 1.53569 5.28587 2.78593C4.03563 4.03618 3.33325 5.73187 3.33325 7.49998V11.6666C3.33325 12.1087 3.15766 12.5326 2.8451 12.8452C2.53254 13.1577 2.10861 13.3333 1.66659 13.3333C1.20635 13.3333 0.833252 13.7064 0.833252 14.1666C0.833252 14.6269 1.20635 15 1.66659 15H18.3333V13.3333ZM8.14011 16.7791C8.53821 16.5482 9.04815 16.6837 9.27909 17.0818C9.35234 17.2081 9.45749 17.3129 9.58399 17.3858C9.7105 17.4587 9.85393 17.497 9.99992 17.497C10.1459 17.497 10.2893 17.4587 10.4158 17.3858C10.5424 17.3129 10.6475 17.2081 10.7208 17.0818C10.9517 16.6837 11.4616 16.5482 11.8597 16.7791C12.2578 17.0101 12.3934 17.52 12.1624 17.9181C11.9427 18.297 11.6272 18.6114 11.2477 18.83C10.8682 19.0486 10.4379 19.1637 9.99992 19.1637C9.56195 19.1637 9.13166 19.0486 8.75214 18.83C8.37261 18.6114 8.05718 18.297 7.83742 17.9181C7.60648 17.52 7.742 17.0101 8.14011 16.7791Z"
                    fill="#23331A"
                  />
                </svg>
                <span class="controlBadgeCount">10</span>
              </div> -->
              <div class="controlBtn btn_user_act dropdown">
                <a href="#"
                   data-toggle="dropdown"
                   class="userAccountDetails dropdown-toggle">
                  <div class="user_info_avi">
                    <img :src="userAvatar"
                         alt="" />
                    <div class="default_avi">{{user.fullName | initials}}</div>
                  </div>
                  <span
                        class="control_label">{{ user ? user.fullName : '***'}}</span>
                  <span class="caret"></span>
                </a>
                <div class="dropdown-menu">
                  <ul class="dpd_nav">
                    <li>
                      <router-link :to="{ name: 'offtaker.profile'}">
                        My Profile
                      </router-link>
                    </li>
                    <li>
                      <router-link :to="{name: 'offtaker.editprofile'}">
                        Account Settings
                      </router-link>
                    </li>
                    <li>
                      <a href="#"
                         @click="logout"> Log Out </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="controlBtn nav_trigger">
                <a class="primary-nav-trigger"
                   href="#">
                  <span class="menu-icon"></span>
                  <span class="menu-text sr-only">Menu</span>
                </a>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>

    <router-view />
  </section>

</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import CartItem from '@/components/off-taker/CartItem';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["user", "states"]),
    ...mapState('offtaker', ['cart']),
    userAvatar() {
      return this.user && this.user.avatar ? this.user.avatar : "";
    }
  },
  methods: {
    ...mapActions(["logoutUser", "getStates"]),
    ...mapMutations(["login_user"]),
    ...mapMutations('offtaker', ['clear_cart']),
    ...mapActions('offtaker', ['addToCart']),
    logout() {
      this.logoutUser();
      this.$router.push({
        name: "login"
      });
    },
    getCartItems() {
      this.$http.get('cart_items')
      .then((response) => {
        this.addToCart(response.data)
      })
      .catch((error) => {
        this.$toastr.error(error)
      })
    },
    clearCart() {
      this.$http.delete('cart_items')
        .then((res) => {
            console.log('Deleted ',res.data)
            this.clear_cart();
            this.$toastr.success('Cart cleared')
        })
        .catch((error) => {
            this.$toastr.error(error)
        })
        
    },

    checkStates() {
      if (this.states.length === 0) {
        this.getStates();
      }
    },

    viewCart() {
      this.$router.push({
        name: 'offtaker.shoppingcart'
      })
    }
  },

  created() {
    // this.checkToken();
    // this.checkFarm();
    this.checkStates();
    this.getCartItems();
    // this.checkOffers();
  },
  components: {
    CartItem
  }
};
</script>

<style scoped src="../../../public/assets/css/farmerspage.css">
</style>
